import { NgTemplateOutlet } from '@angular/common';
import * as i0 from '@angular/core';
import { input, output, ViewEncapsulation, ChangeDetectionStrategy, Component } from '@angular/core';
import * as i1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

/** Only use this component when you absolutely need to dynamically switch the type. Otherwise just use the material buttons directly */
const _c0 = ["*"];
function ZvButton_Case_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.icon());
  }
}
function ZvButton_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵtemplate(1, ZvButton_Case_0_Conditional_1_Template, 2, 1, "mat-icon");
    i0.ɵɵelementContainer(2, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(6);
    i0.ɵɵclassMap("zv-btn-" + ((tmp_2_0 = ctx_r0.color()) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "default"));
    i0.ɵɵproperty("color", ctx_r0.color())("disabled", ctx_r0.disabled());
    i0.ɵɵattribute("data-cy", ctx_r0.dataCy());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.icon() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function ZvButton_Case_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.icon());
  }
}
function ZvButton_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵtemplate(1, ZvButton_Case_1_Conditional_1_Template, 2, 1, "mat-icon");
    i0.ɵɵelementContainer(2, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(6);
    i0.ɵɵclassMap("zv-btn-" + ((tmp_2_0 = ctx_r0.color()) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "default"));
    i0.ɵɵproperty("color", ctx_r0.color())("disabled", ctx_r0.disabled());
    i0.ɵɵattribute("data-cy", ctx_r0.dataCy());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.icon() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function ZvButton_Case_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.icon());
  }
}
function ZvButton_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵtemplate(1, ZvButton_Case_2_Conditional_1_Template, 2, 1, "mat-icon");
    i0.ɵɵelementContainer(2, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(6);
    i0.ɵɵclassMap("zv-btn-" + ((tmp_2_0 = ctx_r0.color()) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "default"));
    i0.ɵɵproperty("color", ctx_r0.color())("disabled", ctx_r0.disabled());
    i0.ɵɵattribute("data-cy", ctx_r0.dataCy());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.icon() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function ZvButton_Case_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.icon());
  }
}
function ZvButton_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵtemplate(1, ZvButton_Case_3_Conditional_1_Template, 2, 1, "mat-icon");
    i0.ɵɵelementContainer(2, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(6);
    i0.ɵɵclassMap("zv-btn-" + ((tmp_2_0 = ctx_r0.color()) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "default"));
    i0.ɵɵproperty("color", ctx_r0.color())("disabled", ctx_r0.disabled());
    i0.ɵɵattribute("data-cy", ctx_r0.dataCy());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.icon() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function ZvButton_Case_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.icon());
  }
}
function ZvButton_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵtemplate(1, ZvButton_Case_4_Conditional_1_Template, 2, 1, "mat-icon");
    i0.ɵɵelementContainer(2, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(6);
    i0.ɵɵclassMap("zv-btn-" + ((tmp_2_0 = ctx_r0.color()) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "default"));
    i0.ɵɵproperty("color", ctx_r0.color())("disabled", ctx_r0.disabled());
    i0.ɵɵattribute("data-cy", ctx_r0.dataCy());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.icon() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function ZvButton_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
let ZvButton = /*#__PURE__*/(() => {
  class ZvButton {
    elementRef;
    type = input('default');
    color = input(null);
    icon = input(null);
    dataCy = input(null);
    disabled = input(false);
    // We want to call it like the dom-click event because catching a click event should work as expected for buttons as well
    // eslint-disable-next-line @angular-eslint/no-output-native
    click = output();
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.elementRef.nativeElement.addEventListener('click', this.captureClick, true);
    }
    ngOnDestroy() {
      this.elementRef.nativeElement.removeEventListener('click', this.captureClick, true);
    }
    captureClick = event => {
      if (this.disabled()) {
        event.stopPropagation();
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }
      return true;
    };
    static ɵfac = function ZvButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvButton)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvButton,
      selectors: [["zv-button"]],
      inputs: {
        type: [1, "type"],
        color: [1, "color"],
        icon: [1, "icon"],
        dataCy: [1, "dataCy"],
        disabled: [1, "disabled"]
      },
      outputs: {
        click: "click"
      },
      ngContentSelectors: _c0,
      decls: 7,
      vars: 1,
      consts: [["content", ""], ["mat-flat-button", "", "type", "button", 3, "color", "class", "disabled"], ["mat-stroked-button", "", "type", "button", 3, "color", "class", "disabled"], ["mat-raised-button", "", "type", "button", 3, "color", "class", "disabled"], ["mat-icon-button", "", "type", "button", 3, "color", "class", "disabled"], ["mat-button", "", "type", "button", 3, "color", "class", "disabled"], ["mat-flat-button", "", "type", "button", 3, "color", "disabled"], [3, "ngTemplateOutlet"], ["mat-stroked-button", "", "type", "button", 3, "color", "disabled"], ["mat-raised-button", "", "type", "button", 3, "color", "disabled"], ["mat-icon-button", "", "type", "button", 3, "color", "disabled"], ["mat-button", "", "type", "button", 3, "color", "disabled"]],
      template: function ZvButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ZvButton_Case_0_Template, 3, 7, "button", 1)(1, ZvButton_Case_1_Template, 3, 7, "button", 2)(2, ZvButton_Case_2_Template, 3, 7, "button", 3)(3, ZvButton_Case_3_Template, 3, 7, "button", 4)(4, ZvButton_Case_4_Template, 3, 7, "button", 5)(5, ZvButton_ng_template_5_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          let tmp_1_0;
          i0.ɵɵconditional((tmp_1_0 = ctx.type()) === "flat" ? 0 : tmp_1_0 === "stroked" ? 1 : tmp_1_0 === "raised" ? 2 : tmp_1_0 === "icon" ? 3 : 4);
        }
      },
      dependencies: [MatButtonModule, i1.MatButton, i1.MatIconButton, NgTemplateOutlet, MatIcon],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ZvButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// export what ./public_api exports so we can import with the lib name like this:
// import { ModuleA } from 'libname'

/**
 * Generated bundle index. Do not edit.
 */

export { ZvButton };
